import { Link } from 'react-router-dom';

export default function FinalCta() {
  return (
    <section
      id="final-cta"
      className="relative pt-[46px] pb-[46px] md:pt-[78px] md:pb-[78px] lg:pt-[110px] lg:pb-[110px] overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/50e839e9-6de5-44e0-9a2d-45e0ddfab608_compressed_pexels-divinetechygirl-1181562.webp)',
        }}
      />

      {/* Brown gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-amber-900/85 via-amber-800/70 to-amber-900/85" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16 text-center">
        <div className="reveal-on-scroll">
          <p className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-background-50/70 mb-6">
            Da el primer paso
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-[60px] leading-[1.1] font-light text-background-50 max-w-[820px] mx-auto mb-8">
            ¿Te gustaría llevar tu crecimiento profesional al siguiente nivel?
          </h2>
          <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-[620px] mx-auto mb-12">
            Agenda una sesión inicial sin costo para que juntos descubramos cómo la mentoría
            estratégica y el método CALMA pueden ayudarte a potenciar tu carrera profesional.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/agenda"
              className="px-8 py-3.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-background-50 text-amber-900 hover:bg-background-100"
            >
              Agenda una sesión
            </Link>
            <Link
              to="/contacto"
              className="px-8 py-3.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer border border-background-50/40 text-background-50 hover:bg-background-50/10"
            >
              Contáctame
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}